import React from 'react'
import {Context as AppContext}  from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import CreateExternalWarehousingCost from './create'

import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'

import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'

import Table from '../../components/MUITable'

const ExternalWarehousingCostToolbar = (props) => {
  const { selected, add, remove, clean, edit, vendor } = props

  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const deleteConfirmation = () => setDeleteDialog(true)
  const confirmDelete = () => remove(selected.id) || setDeleteDialog(false)
  const closeDelete = () => setDeleteDialog(false)

  const [cleanDialog, setCleanDialog] = React.useState(false)
  const cleanConfirmation = () => setCleanDialog(true)
  const confirmClean = () => clean() || setCleanDialog(false)
  const closeClean = () => setCleanDialog(false)

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Costos de almacenamiento
        <Dialog onClose={closeDelete} open={deleteDialog}>
          <DialogTitle>Eliminar</DialogTitle>
          <Button onClick={confirmDelete}>Ok</Button>
        </Dialog>
        <Dialog onClose={closeClean} open={cleanDialog}>
          <DialogTitle>Limpiar</DialogTitle>
          <Button onClick={confirmClean}>Ok</Button>
        </Dialog>
      </Typography>
      {selected && 
        <React.Fragment>
          <Tooltip title="Editar">
            <IconButton onClick={() => edit(selected.id)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton onClick={deleteConfirmation}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      }
      <Tooltip title="Añadir costo de almacenamiento">
        <IconButton onClick={add} disabled={!vendor}>
          <AddIcon />
          {!vendor && "Seleccione un canal de venta"}
        </IconButton>
      </Tooltip>
      <Tooltip title="Limpiar costos pasados">
        <IconButton onClick={cleanConfirmation}>
          <DeleteSweepIcon />
        </IconButton>
        
      </Tooltip>
    </Toolbar>
  )
}

const ExternalWarehousingCost = () => {
  const { vendor} = React.useContext(AppContext)
  const SalesChannels = React.useContext(SalesChannelsContext)  
  const { current } = SalesChannels
  const { externalwarehousingCosts, clean, remove, detail } = SalesChannels.externalwarehousingCosts
  const [open, setOpen] = React.useState(false)
  const [selected, setSelected] = React.useState([])

  const openD = (s) => {
    setOpen(true)
  }
  React.useEffect(() => {
    if(selected.length == 1)
      detail(externalwarehousingCosts[selected[0]-1])
    else
      detail(null)
  }, [selected])

  return (
    <Stack sx={{ width: '90vw', }}>
      <ExternalWarehousingCostToolbar vendor={vendor} selected={current} add={openD} edit={openD} remove={remove} clean={clean}/>
      <Paper sx={{ padding: "30px",  height:'80vh', display: 'flex', flexDirection: 'column' }}>
        <Table
            model={selected}
            setmodel={setSelected}
            data={externalwarehousingCosts || []}
            columns={[
              {flex: 1, headername: "Fecha", field: "date",
                valueGetter: (value, row) => row.date ? new Date(row.date).toISOString().split('T')[0] : '-'
              },
              {flex: 1, headername: "Costo", field: "cost"},
              {flex: 1, headername: "Estado", field: "status"},
              {flex: 3, headername: "Producto", field: "product",
                valueGetter: (value, row) => row.product? row.product.name : ""
              },
              {flex: 1, headername: "Canal de venta", field: "vendor"},
            ]}
            options={{
              selection: true,
              pageSizes:[5, 10,25,50,100,250,500]
            }}
            sx={{
              '& .MuiDataGrid-cellContent': {
              overflow: 'scroll',
              textOverflow: 'unset',
              }
            }}
          />
      </Paper>
      <CreateExternalWarehousingCost model={current} open={open} close={() => setOpen(false)}/>
    </Stack>
  )
}
export default ExternalWarehousingCost